import Inputc from '../../components/input.vue'
import {StorageUtil, LocalStorageUtil} from '../../common/Auth.js';
import {api, msg} from '../../common/config.js';
import {ajaxUtil} from '../../common/AjaxUtil.js';
import {validateUtil} from '../../common/ValidateUtil.js';
import {CommonUtil} from '../../common/CommonUtil.js';
import {store} from '../../store/store.js'

export default {
    name: 'changephone',
    components: {
        Inputc,
    },
    data() {
        return {
            oldPhone: '',
            newPhone: '',
            code: '',
            sendPassword: {
                canClick: true,
                value: "发送验证码",
                countNumber: "",
            },
            isSend: 0,//0未发送,1发送
        }
    },
    mounted() {
        if (store.func.getUserObj() == null) {
            store.index.$refs.login.showLogin();
            return;
        }
        this.oldPhone = store.func.getUserObj().phone || '';
        var url = api.personalnews.overdue.replace('{idCard}', store.user.idCard);
        ajaxUtil.ajaxJson(url, null, 'GET', (data) => {
        }, (result) => {
            /*if (result.errorCode == 30100) {
              if (result.message === '登录超时,请重新登录'){
                store.index.$refs.login.showLogin();
                return;
              }
              store.index.$refs.login.showLogin();
            }*/
        }, this);
    },
    methods: {
        //发送验证码
        validatePhone: function (callback) {
            var phoneMsg = validateUtil.validate([{name: 'phone'}, {name: 'required'}], this.newPhone);
            if (phoneMsg != null) {
                this.$refs.a.showError(msg.phoneError);
                return;
            } else if (this.oldPhone == this.newPhone) {
                this.$refs.a.showError(msg.phoneRepetition);
                return;
            }
            var url = api.reader.preUserInfo.replace('{phone}', this.newPhone);
            ajaxUtil.ajaxJson(url, '', 'get', (data) => { //成功
                if (data != null) {
                    this.$refs.a.showError(msg.phoneExist);
                } else {
                    callback();
                }
            }, (result) => { //失败
                if (result.errorCode == 30108) {
                    this.$refs.a.showError(msg.phoneError);
                }
            }, this);
        },
        sendSMS: function () {
            this.validatePhone(() => {
                if (this.newPhone.trim() == null || this.newPhone.trim() == "") {
                    return false;
                }
                var phone = this.newPhone;
                var url = api.reader.modifySend;
                ajaxUtil.ajaxJson(url, {'phone':phone}, 'post', (data) => { //成功
                    this.isSend = 1;
                    this.countdown(60);
                    CommonUtil.setInfo(msg.sendCode);
                }, (result) => { //失败
                    this.sendPassword.canClick = true;
                    CommonUtil.setInfo(msg.sendCodeError);
                }, this);
            });


        },
        //提交
        submit: function () {
            // 首先校验手机号码
            this.validatePhone(() => {
                var url = api.reader.modifyPhone;
                var submitData = {
                    code: this.code,
                    idCard: StorageUtil.getObject("user").idCard,
                    phone: this.newPhone
                };
                ajaxUtil.ajaxJson(url, submitData, 'post', (data) => { //成功
                    this.oldPhone = submitData.phone;
                    var user = StorageUtil.getObject("user");
                    var phone = submitData.phone;
                    user.phone = phone;
                    store.user = user;
                    StorageUtil.storeObject("user", user);
                    this.code = "";
                    this.newPhone = "";
                    this.sendPassword.canClick = true;
                    CommonUtil.setInfo(msg.updatePhoneSuccess);
                    this.$router.push('/borrow');
                }, (result) => { //失败
                    if (result.errorCode == 30106) {
                        CommonUtil.setInfo(msg.codeError);
                    } else {
                        CommonUtil.setInfo(msg.updatePhoneError);
                    }
                }, this);
            });
        },

        //倒计时
        countdown: function (initCount) {
            if (initCount < 0) {
                return
            }
            var _this = this;
            _this.sendPassword.canClick = false;
            _this.sendPassword.value = "秒后再次发送";
            var intervalId = setInterval(function () {
                initCount--;
                if (initCount <= 0) {
                    clearInterval(intervalId);
                    _this.sendPassword.countNumber = "";
                    _this.sendPassword.canClick = true;
                    var value;
                    if (_this.isSend == 1) {
                        value = "再次发送";
                    } else {
                        value = "发送验证码";
                    }
                    _this.sendPassword.value = value;
                    return;
                } else {
                    _this.sendPassword.countNumber = initCount;
                }
            }, 1000);
        },
    }
}
